import defaultAttributes from '../defaultAttributes';

const ChevronRight = [
  'svg',
  defaultAttributes,
  [['polyline', { points: '9 18 15 12 9 6' }]],
];

export default ChevronRight;
